import createSelectors from './createSelectors';
import CSVInputSchema from '../models/CSVInputSchema';

const Select = createSelectors(CSVInputSchema, {});

export default Select;
